'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiContacts = function TiContacts(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 5h-18.4c-2.7 0-5 2.2-5 5v1.7h-1.6c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7h1.6v3.3h-1.6c-1 0-1.7 0.8-1.7 1.7s0.7 1.7 1.7 1.7h1.6v3.3h-1.6c-1 0-1.7 0.8-1.7 1.7s0.7 1.6 1.7 1.6h1.6v1.7c0 2.8 2.3 5 5 5h18.4c2.7 0 5-2.2 5-5v-20c0-2.8-2.3-5-5-5z m-20 5c0-0.9 0.7-1.7 1.6-1.7v3.4h-1.6v-1.7z m0 5h1.6v3.3h-1.6v-3.3z m0 6.7h1.6v3.3h-1.6v-3.3z m0 8.3v-1.7h1.6v3.4c-0.9 0-1.6-0.8-1.6-1.7z m21.6 0c0 0.9-0.7 1.7-1.6 1.7h-16.7v-23.4h16.7c0.9 0 1.6 0.8 1.6 1.7v20z m-6.6-12.5c0 1.8-1.5 3.3-3.4 3.3s-3.3-1.5-3.3-3.3c0-1.8 1.5-3.3 3.3-3.3s3.4 1.5 3.4 3.3z m-3.4 4.8c-2.6 0-4.1 1.2-4.1 2.3 0 0.6 1.5 1.2 4.1 1.2 2.5 0 4.2-0.6 4.2-1.2 0-1.1-1.6-2.3-4.2-2.3z' })
        )
    );
};

exports.default = TiContacts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/contacts.js
// module id = 3594
// module chunks = 0